import React from 'react';
import { CardsLayout } from "./types/ContactCards.types";
import { ContactCardModel } from "./models/ContactCard.model";
import {
    Image,
    Link,
    RichText,
    isEditorActive,
} from "@sitecore-jss/sitecore-jss-react";

const FullCard = (props) => {
    const { contactCardList, onReadMoreHandler } = props
    return (
        <div className={`contact-cards contact-cards--${CardsLayout['1ColumnLayout']}`}>
            {
                contactCardList.map((item, index) => {
                    const card = new ContactCardModel(item);
                    return (
                        <div className="contact-card" key={index}>
                            <div className="contact-card__1-column-image--wrapper">
                                <Image
                                    loading="lazy"
                                    field={card?.cardImageDesktop}
                                    className="contact-card__1-column-image--desktop"
                                />
                            </div>
                            <div className="contact-card__content-wrapper">
                                <div className="contact-card__content">
                                    <RichText
                                        className=" contact-card__fullname"
                                        field={card?.fullname}
                                        tag="h3"
                                    />
                                    <RichText
                                        className=" contact-card__designation"
                                        field={card?.designation}
                                        tag="p"
                                    />
                                </div>

                                <div className="contact-card__footer">
                                    {(card?.CTA?.value?.text || card?.CTA?.value?.href) && (
                                        <div className="contact-card__cta-link cta cta-primary cta-primary-white2">
                                            {isEditorActive() && (
                                                <Link
                                                    field={card?.CTA}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        onReadMoreHandler(card);
                                                    }}
                                                />
                                            )}

                                            {card?.description?.value && card.CTA ? (
                                                <Link
                                                    field={card?.CTA}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        onReadMoreHandler(card);
                                                    }}
                                                />
                                            ) : (
                                                <Link field={card?.CTA} />
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default FullCard;